import FRAGMENT_SHADER from "./shaders/base-overlay.fs";
import VERTEX_SHADER from "./shaders/base-overlay.vs";

class BaseOverlay extends THREE.Mesh {
    constructor() {
        const rt = new THREE.WebGLRenderTarget(2048, 2048);
        const geometry = new THREE.PlaneBufferGeometry(2, 2, 1, 1);
        const material = new THREE.ShaderMaterial({
            uniforms: { map: { value: rt.texture } },
            transparent: true,
            vertexShader: VERTEX_SHADER,
            fragmentShader: FRAGMENT_SHADER,
            depthTest: false,
            depthWrite: false,
            // wireframe: true,
            // blending: THREE.CustomBlending,
            // blendSrc: THREE.SrcAlphaFactor, //default
            // blendDst: THREE.DstAlphaFactor //default
        });

        super(geometry, material);

        this._rt = rt;
        this.isOverlay = true;
        this.frustumCulled = false;
        this.scale.set(1e-5, 1e-5, 1e-5);
        this.position.set(Infinity, Infinity, Infinity);
        this.renderOrder = Infinity;
    }

    get rt() { return this._rt; }

    clear(renderer) {
        const lastTarget = renderer.getRenderTarget();
        renderer.setRenderTarget(this._rt);
        renderer.clear();
        renderer.setRenderTarget(lastTarget);
    }
    render(renderer, scene, camera, params) { throw new Error("Must be implemented in inheriting class."); }
}

export default BaseOverlay;
export { BaseOverlay };